import { Component, Vue, } from 'vue-property-decorator';
import { NavigationItem } from '@/components/navigation/Navigation';
import Attributes from '@/views/Settings/Attributes/Attributes';
import Brands from '@/views/Settings/Brands/Brands';
import Categories from '@/views/Settings/Categories/Categories';
import Colors from '@/views/Settings/Colors/Colors';
import Seasons from "./Seasons/Seasons";
import Sizes from './Sizes/Sizes';
import Tags from './Tags/Tags';
import Materials from './Materials/Materials.vue';
import Suppliers from './Suppliers/Suppliers';
import SettingsSupplierSizes from '@/views/Settings/SupplierSizes/SupplierSizes.vue';
import SettingsSupplierSizeDeviations from '@/views/Settings/SupplierSizeDeviations/SupplierSizeDeviations.vue';
import SettingsSupplierSizePacks from '@/views/Settings/SupplierSizePacks/SupplierSizePacks.vue';
import KlaviyoSync from '@/views/Settings/KlaviyoSync/KlaviyoSync';
import MaiaInstructions from '@/views/Settings/MaiaInstructions/MaiaInstructions';
import { RoleEnum, User } from '@/models/User';
// import HourTypes from '@/views/Settings/HourTypes/HourTypes';
// import SubscriptionTypes from '@/views/Settings/SubscriptionTypes/SubscriptionTypes';
// import EmployeeTypes from '@/views/Settings/EmployeeTypes/EmployeeTypes';
// import Tenants from '@/views/Tenants/Tenants';
// import Locations from '@/views/Settings/Locations/Locations';
// import CostTypes from '@/views/Settings/CostTypes/CostTypes';
// import MasterData from '@/views/Settings/MasterData/MasterData';
// import Tariffs from '@/views/Settings/Tariffs/Tariffs';
// import VatCodes from '@/views/Settings/VatCodes/VatCodes';
// import Ledgers from '@/views/Settings/Ledgers/Ledgers';

@Component<Settings>({
  components: {
    Attributes,
    Brands,
    Categories,
    Colors,
    Seasons,
    Sizes,
    Suppliers,
    Tags,
    Materials,
    SettingsSupplierSizes,
    SettingsSupplierSizeDeviations,
    SettingsSupplierSizePacks,
    KlaviyoSync,
    MaiaInstructions,
  }
})
export default class Settings extends Vue
{
  public $pageTitle = 'Setting';

  protected items: NavigationItem[] = [
    {
      title: 'Attributes',
      link: '/',
      icon: 'face',
      active: true,
      category: 'attributes',
    },
    {
      title: 'Brands',
      link: '/',
      icon: 'face',
      active: false,
      category: 'brands',
    },
    {
      title: 'Categories',
      link: '/',
      icon: 'face',
      active: false,
      category: 'categories',
    },
    {
      title: 'Colors',
      link: '/',
      icon: 'list',
      active: false,
      category: 'colors',
    },
    {
      title: 'Seasons',
      link: '/',
      icon: 'account_balance_wallet',
      active: false,
      category: 'seasons',
    },
    {
      title: 'Sizes',
      link: '/',
      icon: 'account_balance_wallet',
      active: false,
      category: 'sizes',
    },
    {
      title: 'Supplier sizes',
      link: '/',
      icon: 'account_balance_wallet',
      active: false,
      category: 'supplier-sizes',
    },
    {
      title: 'Supplier size specific per brand',
      link: '/',
      icon: 'account_balance_wallet',
      active: false,
      category: 'supplier-size-deviations',
    },
    {
      title: 'Supplier size packs',
      link: '/',
      icon: 'account_balance_wallet',
      active: false,
      category: 'supplier-size-packs',
    },
    {
      title: 'Suppliers',
      link: '/',
      icon: 'attach_money',
      active: false,
      category: 'suppliers',
    },
    {
      title: 'Tags',
      link: '/',
      icon: 'work',
      active: false,
      category: 'tags',
    },
    {
      title: 'Materials',
      link: '/',
      icon: 'texture',
      active: false,
      category: 'materials',
    },
    {
      title: 'Klaviyo Sync',
      link: '/',
      icon: 'sync',
      active: false,
      category: 'klaviyo-sync',
    },
    {
      title: 'Maia instructions',
      link: '/',
      icon: 'psychology',
      active: false,
      category: 'maia-instructions',
      // /settings is open to stylists and support (Navigation.ts), and this
      // tab rewrites what Maia tells every one of them. The backend is the
      // real boundary — both procedures refuse anyone else — so this only
      // keeps a door out of sight that would not open anyway.
      visible: () => this.canEditMaiaInstructions,
    },
  ];

  public mounted() {
  }

  protected get navigationItems() {
    return this.items.filter((item: NavigationItem) => {
      // NavigationItem.visible is `Function | boolean`, the same shape the
      // main navigation uses, so both forms have to be honoured here.
      if (typeof item.visible === 'function' && !item.visible(item)) {
        return false;
      }

      if (item.visible === false) {
        return false;
      }

      return !item.roles || !item.roles.includes(RoleEnum.ROOT);
    });
  }

  /**
   * Whether this colleague may rewrite Maia's instructions.
   *
   * Computed on the server (App\Services\Maia\MaiaAccess) and shipped as a
   * boolean on the current user, the same way can_use_maia is — the rule is
   * written once so the tab you can see and the endpoint that answers it
   * cannot drift apart. Absent means no.
   */
  protected get canEditMaiaInstructions(): boolean {
    const auth = this.$store && this.$store.state ? this.$store.state.Auth : null;

    return !!auth && (auth as User).can_edit_maia_instructions === true;
  }

  protected isViewActive(category: string) {
    const item = this.items.find((item: NavigationItem) => {
      return item.category === category;
    });

    return item && item.active;
  }

  protected resetActive() {
    const activeItem = this.items.find((item: NavigationItem) => {
      return item.active || false;
    });

    if(activeItem) {
      activeItem.active = false;
    }
  }
}
